import wordFilter from '@aha-app/tinymce-word-paste-filter';

class MicrosoftPasteShim {
  static filter(html) {
    if (!html || !html.includes('schemas-microsoft-com')) {
      return html;
    }
    const defaultWordValidElements =
      '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' +
      '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' +
      'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';

    const options = {
      paste_retain_style_properties: 'all',
      paste_data_images: true,
      paste_word_valid_elements: `${defaultWordValidElements},img[class|src|border=0|alt|title|hspace|vspace|width|height|align|name]`,
    };

    return wordFilter(html, options);
  }
}

export default MicrosoftPasteShim;
